import * as React from "react";
import "./PreferenceSelect.component.css";
import { LabelledElement } from "../../labelled-element/LabelledElement.component";
import { getReactSelectStyleClasses } from "../../../style/style-functions";
import Select from "react-select";
import { useEffect, useState } from "react";
import { preferencesService } from "@modules/preferences/PreferencesService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { HTMLTooltipWrapper } from "../../html-tooltip/HTMLTooltipWrapper.component";
import { ttResetToDefaultButtonDisabled, ttResetToDefaultButton } from "../../../common-strings.util";
export function PreferenceSelect({ label, preferenceName, options, defaultOptionFallback, wideSelect = false, tooltip, tooltipPosition }) {
    const [currentOption, setCurrentOption] = useState(undefined);
    const [defaultOption, setDefaultOption] = useState(undefined);
    useEffect(() => {
        const schemaObj = preferencesService.schema.preferences.properties[preferenceName];
        let defaultValue;
        if (schemaObj !== undefined && schemaObj.type && schemaObj.type === "string") {
            defaultValue = options.find((o) => o.value === schemaObj.default);
        }
        else if (defaultOptionFallback) {
            defaultValue = defaultOptionFallback;
        }
        setDefaultOption(defaultValue);
        const storedValue = preferencesService.getPreferredValue(preferenceName, defaultOption === null || defaultOption === void 0 ? void 0 : defaultOption.value);
        if (storedValue) {
            const storedOption = options.find((o) => o.value === storedValue);
            if (storedOption) {
                setCurrentOption(storedOption);
            }
            else {
                console.warn(`Stored value for preference ${preferenceName} is not a valid option: ${storedValue}`);
                setCurrentOption(defaultValue);
            }
        }
        else {
            setCurrentOption(defaultValue);
        }
    }, []);
    useEffect(() => {
        if (currentOption) {
            preferencesService.updatePreferences([{ key: preferenceName, value: currentOption.value }]);
        }
    }, [currentOption]);
    const handleOptionChange = (option) => {
        var _a;
        if ((option === null || option === void 0 ? void 0 : option.value) !== undefined) {
            setCurrentOption({
                value: option === null || option === void 0 ? void 0 : option.value,
                label: (_a = option === null || option === void 0 ? void 0 : option.label) !== null && _a !== void 0 ? _a : option === null || option === void 0 ? void 0 : option.value
            });
        }
    };
    return (React.createElement(LabelledElement, { label: label, horizontal: !wideSelect },
        React.createElement("div", { className: `preference-select-container ${wideSelect ? "settings-wide-select" : ""}` },
            React.createElement(HTMLTooltipWrapper, { tooltip: tooltip, tooltipPosition: tooltipPosition },
                React.createElement(Select, { onChange: handleOptionChange, options: options, defaultValue: defaultOption, value: currentOption, classNames: getReactSelectStyleClasses(), menuPlacement: "auto", menuPortalTarget: document.body })),
            React.createElement("button", { className: "icon-button", onClick: () => {
                    setCurrentOption(defaultOption);
                }, disabled: currentOption === defaultOption, "data-tooltip": ttResetToDefaultButton(), "data-tooltip-disabled": ttResetToDefaultButtonDisabled(), "data-tooltip-position": tooltipPosition },
                React.createElement(FontAwesomeIcon, { icon: ["fas", "undo"] })))));
}
